import { FormBuilder, FormControl, Validators,AbstractControl } from '@angular/forms';
export const regex = {
    pattern: {
        EMAIL: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-+_!@#$%^&*., ?])[A-Za-z\d-+_!@#$%^&*., ?]{8,16}$/,
        NAME: /^[a-zA-Z ]*$/,
        NAME2: /[a-zA-Z][\\sa-zA-Z]{0,2000}/,
        FULLNAME: /^([a-zA-Z]+|[a-zA-Z]+\s{1}[a-zA-Z]{1,}|[a-zA-Z]+\s{1}[a-zA-Z]{3,}\s{1}[a-zA-Z]{1,})$|[a-zA-Z_ ]+/,
        CONTACT: /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/,
        ZIPCODE: /^[0-9]{5,}\d*$/,
        ADDRESS: /^(?! )[A-Za-z0-9<>{}()"/|;:.,~!?@#$%^=&* ]+$/,
        LINKEDINURL: /((http(s?):\/\/)*([a-zA-Z0-9\-])*\.|[linkedin])[linkedin/~\-]+\.[a-zA-Z0-9/~\-_,&=\?\.;]+[^\.,\s<]/,
        FACEBOOKURL: /(?:(?:http|https):\/\/)?(?:www.)?facebook.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w\-]*)?/,
        TWITTERURL: /http(?:s)?:\/\/(?:www\.)?twitter\.com\/([a-zA-Z0-9_]+)/,
        URL: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
        ANYCONTACTNUMBER: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]{10,18}$/,
        INSTAGRAMURL: /(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com|instagr.am|instagr.com)\/(\w+)/,
        MESSAGE: /^(?! )[A-Za-z0-9<>{}()"/|;:.,'`~!?@#$%^=&* ]*$/,
        AGE_YEAR: /^(?:(?:[1-9]?[0-9]|1[0-9]{2})(?:\.[0-9]{1,4})?|20(?:\.0{1,4})?)$/,
        AGE_MONTH: /^(1[0-1]|[0-9])$/,
        NUMBER: /(^[0-9]{1,2}$)|(^[0-9]{1,2}[\.]{1}[0-9]{1,2}$)\d{0,2}/,
        SPACE:  /^^[^\s]+(\s+[^\s]+)*$/
        

    },
}

export function EmailNoWhitespaceValidator(control: AbstractControl) {
    if (control.value) {
      const trimmedValue = control.value.trim();
      if (trimmedValue !== control.value) {
        control.setValue(trimmedValue);
      }
    }
  
    return Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)(control);
  }